export default __webpack_public_path__ + "static/media/yomafleet_easy_lease.6923fb71.png";